{
  "emailConfig": {
    "title": "Email Configuration",
    "subtitle": "Configure your email client with Siteoplossing mail settings",
    "emailInput": {
      "title": "Your Email Address",
      "label": "Email Address",
      "placeholder": "your-email{'@'}domain.com",
      "description": "Enter your email address to generate configuration files and settings."
    },
    "automatic": {
      "title": "Automatic Configuration",
      "description": "Click to start and configure your email client:",
      "iosMail": "iOS Mail"
    },
    "manual": {
      "title": "Manual Configuration",
      "description": "Use these settings to manually configure your email client:",
      "incoming": {
        "title": "Incoming Email (IMAP)",
        "server": "Server",
        "port": "Port",
        "security": "Security",
        "username": "Username"
      },
      "outgoing": {
        "title": "Outgoing Email (SMTP)",
        "server": "Server",
        "port": "Port",
        "security": "Security",
        "auth": "Authentication",
        "authRequired": "Required"
      },
      "copy": "Copy Configuration"
    },
    "instructions": {
      "title": "Setup Instructions",
      "step1": "Enter your email address above to personalize the configuration.",
      "step2": "For automatic setup, click on your email client to download the configuration file.",
      "step3": "For manual setup, copy the server settings and enter them in your email client.",
      "step4": "Contact support if you need help with the configuration process."
    },
    "tutorial": {
      "back": "← Back to email settings",
      "progress": "Step {current} of {total}",
      "accountLabel": "Account:",
      "stepImageAlt": "Step {step}: {title}",
      "successTitle": "Email successfully set up!",
      "helpDivider": "Need help?",
      "remoteTitle": "Remote setup — 20 minutes",
      "remoteDescription": "We'll set up your email together via a screen-sharing session. Guaranteed to work.",
      "remoteCta": "📅 Schedule a session",
      "remoteNote": "No technical knowledge required"
    },
    "iosTutorial": {
      "badge": "🍎 Set up iOS Mail",
      "title": "Set up iOS Mail via webmail",
      "subtitle": "Follow these {steps} steps to automatically set up your email on your iPhone. Takes less than 3 minutes.",
      "step7OpensSettings": "Opens automatically in Settings",
      "step7EnterEmail": "← Go back to enter your email address",
      "successDescription": "Open the Mail app on your iPhone. Your messages are now loading.",
      "steps": {
        "1": {
          "title": "Go to webmail",
          "description": "Open Safari on your iPhone and go to {webmailHost}"
        },
        "2": {
          "title": "Log in",
          "description": "Enter your full email address and password"
        },
        "3": {
          "title": "Tap 'Automatically configure my device'",
          "description": "Then we'll move to the next screen"
        },
        "4": {
          "title": "Choose IMAP over SSL/TLS",
          "description": "Select 'IMAP over SSL/TLS' in the 'iOS for iPhone/iPad/iPod' row"
        },
        "5": {
          "title": "Tap Proceed",
          "description": "Confirm your choice by tapping Proceed"
        },
        "6": {
          "title": "Accept the notification",
          "description": "Accept the security notification from your browser"
        },
        "7": {
          "title": "Profile downloaded",
          "description": "The configuration profile is ready on your iPhone. Now go to Settings."
        },
        "8": {
          "title": "Open Settings",
          "description": "Return to your home screen and open the Settings app"
        },
        "9": {
          "title": "Tap 'Profile Downloaded'",
          "description": "You'll see a notification at the top. Tap Profile Downloaded."
        },
        "10": {
          "title": "Open the profile",
          "description": "Open the configuration profile installation page"
        },
        "11": {
          "title": "Tap Install",
          "description": "Tap Install in the top right and confirm again with Install"
        },
        "12": {
          "title": "Enter your passcode",
          "description": "Enter your iPhone passcode to continue"
        },
        "13": {
          "title": "Enter your email password",
          "description": "Enter the password for your email account"
        },
        "14": {
          "title": "Your email is successfully set up",
          "description": "The configuration profile is now active on your iPhone."
        },
        "15": {
          "title": "Open the Mail app to get started",
          "description": "Your inbox will now show all messages. Your email works perfectly!"
        }
      }
    },
    "gmailTutorial": {
      "badge": "📧 Set up Gmail",
      "title": "Set up Gmail on your computer",
      "subtitle": "Follow these {steps} steps to automatically set up your email via IMAP in Gmail. Takes less than 5 minutes.",
      "successDescription": "Open your Gmail account in your browser or email client. Your messages are now syncing automatically.",
      "steps": {
        "1": {
          "title": "Open Gmail",
          "description": "Open the Gmail app on your computer or go to gmail.com"
        },
        "2": {
          "title": "Enter your email address",
          "description": "Enter your full email address and click Next"
        },
        "3": {
          "title": "Choose account type",
          "description": "Choose 'Personal (IMAP)' as the account type"
        },
        "4": {
          "title": "Enter your password",
          "description": "Enter your password and click Next"
        },
        "5": {
          "title": "Configure incoming server",
          "description": "Make sure the server shows '{mailServer}' and click Next"
        },
        "6": {
          "title": "Verifying settings",
          "description": "Your settings are being verified. If this succeeds, the settings are configured correctly."
        },
        "7": {
          "title": "Configure outgoing server",
          "description": "Make sure the SMTP server shows '{mailServer}' and click Next"
        },
        "8": {
          "title": "Default configuration",
          "description": "The default configuration can be kept. Click Next to continue"
        },
        "9": {
          "title": "Finish account setup",
          "description": "Change your account name, set your display name and click Next. Done!"
        }
      }
    }
  },
  "checkout": {
    "headingId": "checkout-heading",
    "heading": "Customer & Payment Details",
    "finalize": "Finalize & Checkout",
    "section": {
      "customerPaymentDetails": "Customer & Payment Details"
    },
    "form": {
      "firstnameLabel": "First Name",
      "lastnameLabel": "Last Name",
      "addressLabel": "Street & House Number",
      "postalCodeLabel": "Postal Code",
      "cityLabel": "City",
      "countryLabel": "Country",
      "selectCountryOption": "Select a country",
      "companyLabel": "Company Name",
      "kvkLabel": "Chamber of Commerce Number",
      "vatLabel": "VAT Number",
      "optional": "optional",
      "legalAgreementPrefix": "I agree to the",
      "termsLink": "Terms and Conditions",
      "legalAgreementMiddle": "and have read the",
      "privacyLink": "Privacy Policy",
      "processing": "Processing...",
      "processingCountdown": "({count})",
      "payNow": "Pay Now"
    },
    "blocking": {
      "emailRequired": "Email is required.",
      "completeStep1": "Complete step 1 first."
    },
    "payment": {
      "longProcessingError": "Payment is taking too long. Please try again.",
      "startError": "Something went wrong starting the payment."
    },
    "steps": {
      "step1": {
        "label": "Create account"
      },
      "step2": {
        "label": "Customer details"
      },
      "step3": {
        "label": "Payment"
      }
    },
    "validation": {
      "firstnameRequired": "First name is required",
      "lastnameRequired": "Last name is required",
      "addressRequired": "Street + house number is required",
      "postalCodeRequired": "Postal code is required",
      "cityRequired": "City is required",
      "countryRequired": "Country is required",
      "tosAgreementRequired": "You must agree to the terms and conditions"
    }
  },
  "domain": {
    "subtitle": "Your website's unique address on the internet - choose something catchy so customers can easily find and remember you.",
    "placeholder": "e.g. yourcompany.com",
    "check": "Check",
    "restart": "Try Another Domain",
    "optionalNote": "Not sure which domain fits best? No worries. You can leave this empty - I'll help you decide",
    "askOwnership": {
      "title": "Is this your domain?",
      "yes": "Yes",
      "no": "No"
    },
    "transfer": {
      "title": "Do you want to transfer your domain to us?",
      "subtitle": "I'll manage DNS, email and renewals for you.",
      "transfer": "Yes, Transfer",
      "keep": "Keep with my registrar"
    },
    "notOwned": {
      "title": "What would you like to do next?",
      "subtitle": "This domain is already taken and not yours.",
      "tryAnother": "Try Another Domain",
      "skip": "Continue Without Domain"
    },
    "finalStates": {
      "available": {
        "title": "Perfect! Your domain is available",
        "subtitle": "{domain} will be registered for you",
        "included1": "1-year .com/.net registration included",
        "included2": "Free SSL certificate & security",
        "included3": "Managed DNS & email setup",
        "price": "£15/year • Registered at checkout"
      },
      "transfer": {
        "title": "Domain transfer arranged",
        "subtitle": "{domain} will be transferred to your management",
        "included1": "Complete domain transfer & management",
        "included2": "DNS configuration & email setup",
        "included3": "SSL certificate & security monitoring",
        "timeline": "Transfer takes 1 day"
      },
      "keep": {
        "title": "Using your existing domain",
        "subtitle": "{domain} stays with your current provider",
        "included1": "DNS configuration instructions provided",
        "included2": "SSL setup guidance included",
        "included3": "Technical support for connection",
        "cost": "No extra cost • You manage renewals"
      },
      "deferred": {
        "title": "Domain selection skipped",
        "subtitle": "You can add a domain later if needed",
        "included1": "Website works without custom domain",
        "included2": "Add domain when you want after launch",
        "included3": "Full setup support when you're ready",
        "cost": "No extra cost now"
      },
      "consultation": {
        "title": "Domain consultation scheduled",
        "subtitle": "We'll choose the perfect domain together",
        "included1": "Domain brainstorming session",
        "included2": "Market research & recommendations",
        "included3": "Registration arranged for you",
        "cost": "Consultation included • Domain at cost"
      }
    },
    "footer": ".com and .net domains only £15/year • Free SSL included • Managed DNS"
  },
  "customPackage": {
    "mentalHeadline": "Just 3 quick steps to select your package",
    "mentalSubline": "Select which packages you want, connect your domain or leave it empty, and review for checkout. Takes less than 5 minutes.",
    "limitedLabel": "Limited Time:",
    "limitedOffer": "21% VAT waived - limited to my first £20,000 in orders",
    "summaryTitle": "Your Package Overview",
    "croBridgeBody": "Based on your situation, I've pre-selected the best combination to get started. You can adjust everything below, but most users find this setup ideal.",
    "croBridgeBodyPersonalized": "Based on your situation, I've pre-selected the best combination to get started. You can adjust everything below, but most users find this setup ideal.",
    "croBridgeBodyGeneric": "Here's our most popular combination to get started right away. This setup includes everything you need for a professional online presence.",
    "step1Title": "Build Your Package",
    "step2Title": "Your Domain Name",
    "step3Title": "Review & Launch"
  },
  "pricing": {
    "plan": "Plan",
    "features": "Features",
    "price": "Price",
    "includes_tax": "*VAT exemption applies under UK small business rules",
    "mostPopular": "Most Popular",
    "breakdownTitle": "Cost Breakdown",
    "breakdownSubtitle": "Crystal clear costs, zero surprises",
    "summary": {
      "oneTimeServices": "One-time services",
      "monthlyBilledPlans": "Monthly billed subscriptions",
      "yearlyBilledPlans": "Yearly billed subscriptions",
      "vat": "VAT",
      "totalDueToday": "Total due today"
    },
    "upcoming": {
      "switchHint": "Want fewer invoices? Switch to Yearly below and I'll bundle everything into one annual payment.",
      "afterToday": {
        "title": "After Today – Your Future Payments",
        "subtitle": "What happens after you pay the 'Total Due Today'."
      },
      "pill": {
        "monthly": {
          "note": "Next payment on {date} • monthly billed for 12 months. Ends on {endDate}",
          "aria": "Monthly payments for the next 12 months"
        },
        "yearly": {
          "zero": {
            "note": "Relax — nothing due until {date}.",
            "aria": "No payments during current yearly period"
          },
          "note": "After 12 months, renewal on {date}.",
          "aria": "Renewal amounts billed yearly",
          "planBilledYearly": "Subscription billed yearly."
        },
        "renewal": {
          "monthly": {
            "note": "After 12 months renewal begins: monthly billed.",
            "aria": "Renewal amounts after first year",
            "yearlyDomainRenewal": " Plus yearly domain renewal."
          }
        }
      },
      "label": {
        "current": "Next 12 months",
        "renewal": "Renewal"
      }
    }
  },
  "billing": {
    "monthly": "Monthly",
    "yearly": "Yearly",
    "oneTime": "One-time",
    "shortLabels": {
      "monthly": "/ mo",
      "yearly": "/ yr",
      "year": "/ year"
    }
  },
  "plans": {
    "billingLabels": {
      "monthly": "per month",
      "yearly": "per year",
      "oneTime": "one-time"
    },
    "webHosting_total": {
      "displayName": "Complete Website Package",
      "rationale": "All-in-one starter package to get your website live - 5 pages and 1200 words with hosting, setup and email",
      "features": [
        "Web hosting (5GB SSD)",
        "Business email",
        "Pre-installed CMS with basic theme",
        "3-5 pages",
        "1200 words",
        "1x onboarding call (20 min)",
        "1 revision"
      ]
    },
    "webHosting_pro": {
      "displayName": "Complete Website Package Extended",
      "rationale": "For when you need more space and priority support",
      "features": ["Everything from Complete package", "20GB SSD hosting", "Priority support (email + chat)"]
    },
    "domain_managed": {
      "displayName": "Domain Management Service",
      "rationale": "I register and manage your domain - no technical hassle, fully secure",
      "features": ["1x .com/.net domain registration", "DNS & email setup done for you"]
    },
    "techConcierge_free": {
      "displayName": "Tech Concierge: Standard",
      "rationale": "Essential maintenance and quick fixes to keep your site running smoothly.",
      "features": [
        "Nightly backups & off-site storage",
        "Weekly security & health scans",
        "20-min monthly quick adjustments",
        "Access to knowledge base"
      ]
    },
    "techConcierge_extra_5h": {
      "displayName": "Tech Concierge: Package (5h)",
      "rationale": "Extra dedicated time for custom adjustments and features. Use in one go or multiple steps.",
      "features": [
        "Total 5h dedicated hands-on support",
        "Priority ticket queue",
        "We make quick adjustments so you don't have to"
      ]
    },
    "techConcierge_5h": {
      "displayName": "Dev Concierge: Dev Sprint (5h Package)",
      "rationale": "Want something special built? This 5-hour package gives you custom development without monthly commitments.",
      "features": [
        "5h dedicated dev time (one-time use)",
        "Use cases: API integrations, theme customizations",
        "2x 1-on-1 dev calls (scope + review)",
        "Code handover with documentation",
        "No ongoing commitments",
        "5-day delivery guaranteed"
      ]
    },
    "growthCall_monthly": {
      "displayName": "Monthly Growth Strategy Call",
      "rationale": "Stay ahead with data-driven insights and expert guidance. This comprehensive package offers extensive growth tracking with personal strategy sessions.",
      "features": [
        "Custom analytics dashboard (GA4 + Clarity + Meta + Hotjar)",
        "Traffic & conversion insights with actionable recommendations",
        "SEO + content gap analysis with competitor insights",
        "CRO opportunity alerts and A/B test suggestions",
        "Monthly strategy call with growth specialist",
        "Email & PDF report with video walkthrough every 30 days"
      ]
    },
    "humanContent_business": {
      "displayName": "Authority Content Accelerator",
      "rationale": "Establish yourself as an authority in your market through strategic content that drives engagement and positions you as an industry thought leader.",
      "features": [
        "4 long-form articles (2,500+ words each)",
        "Thought leadership positioning strategy",
        "SEO optimization with keyword targeting",
        "Social media content calendar (16 posts)",
        "Email newsletter templates (4 per month)",
        "Content performance analytics report"
      ]
    },
    "seo_booster": {
      "displayName": "SEO Opportunity Amplifier",
      "rationale": "Explore your SEO potential with deep analysis and strategic optimization. Perfect for businesses ready to get on Google's first page",
      "features": [
        "Comprehensive site structure audit & optimization plan",
        "Internal linking strategy with 50+ link opportunities",
        "5 content clusters with topic mapping & keyword research",
        "Search intent optimization for 20+ key pages",
        "Technical SEO fixes & page speed optimization",
        "Competitor gap analysis & content strategy",
        "90-day SEO roadmap with monthly milestones"
      ]
    },
    "cro_booster": {
      "displayName": "CRO Conversion Accelerator",
      "rationale": "Transform visitors into buyers with data-driven conversion optimization. A scientific approach to maximize your website's performance.",
      "features": [
        "Complete conversion funnel audit & heatmap analysis",
        "User behavior analysis with session recordings",
        "UX/UI optimization for 3 high-impact pages",
        "A/B test setup for headlines, CTAs & page layouts",
        "Landing page optimization with mobile responsiveness",
        "Conversion tracking & goal setup in analytics",
        "60-day optimization roadmap with test calendar",
        "Monthly performance review call"
      ]
    },
    "content_strategy": {
      "displayName": "Content Strategy Intensive",
      "rationale": "Build a content foundation for consistent growth. A strategic content approach to convert prospects into customers.",
      "features": [
        "Comprehensive content audit & competitor analysis",
        "Content pillars & messaging framework development",
        "Editorial calendar for 6 months with topic clusters",
        "SEO content strategy with keyword mapping",
        "Brand voice guide & content style documentation",
        "Content distribution strategy across all channels",
        "Performance measurement framework & KPIs",
        "2 strategy sessions + monthly check-ins for 3 months"
      ]
    },
    "branding_mini": {
      "displayName": "Mini Brand Refresh",
      "rationale": "A strategic visual refresh that modernizes your brand without starting from scratch. Perfect for established businesses needing a contemporary update.",
      "features": [
        "Logo refinement with 2 variations (color/mono)",
        "Color palette optimization (5 brand colors + shades)",
        "Typography system with primary & secondary fonts",
        "3 redesigned desktop page mockups",
        "Brand guidelines summary (PDF)",
        "2 revision rounds included",
        "Social media logo variations (4 formats)"
      ]
    },
    "branding_full": {
      "displayName": "Complete Brand Evolution",
      "rationale": "Transform your complete visual identity with a comprehensive brand system. Everything needed for consistent, professional brand presentation.",
      "features": [
        "Everything from Mini package",
        "3 logo variations (full color, single color, icon)",
        "Extended color, typography & spacing system",
        "8 brand element suggestions (patterns, textures, icons)",
        "Complete style guide (PDF + Figma source files)",
        "6 page mockups (3 desktop + 3 mobile)",
        "Business card & letterhead design",
        "Social media brand kit (20+ templates)",
        "3 rounds feedback and refinement",
        "Brand application guidelines document"
      ]
    },
    "branding_premium": {
      "displayName": "Signature Brand Experience",
      "rationale": "The ultimate brand transformation experience. Strategic positioning meets premium design execution for brands ready to lead their market.",
      "features": [
        "Everything from Complete package",
        "Strategic brand positioning workshop (2 sessions)",
        "Brand story, personality & voice development",
        "Market differentiation analysis & competitor audit",
        "Custom brand photography art direction guide",
        "10 page mockups (5 desktop + 5 mobile)",
        "Presentation template suite (PowerPoint + Keynote)",
        "Advanced social media brand system (50+ templates)",
        "Brand implementation roadmap & training session",
        "Priority support & unlimited tweaks for 30 days",
        "Express delivery: 10 business days"
      ]
    },
    "brand_audit": {
      "displayName": "Brand Identity Health Check",
      "rationale": "Discover how your brand performs and where to focus improvements. Perfect starting point for major brand investments.",
      "features": [
        "Comprehensive brand audit across all touchpoints",
        "Competitive visual analysis & market positioning review",
        "Brand consistency evaluation (website, social, print)",
        "Customer perception analysis & feedback collection",
        "Visual identity strength/weakness assessment",
        "Detailed improvement recommendations report",
        "60-minute strategy call to discuss findings",
        "30-day action plan with prioritized improvements"
      ]
    }
  },
  "planSelection": {
    "group": {
      "buildLaunch": {
        "title": "Build & Launch",
        "subtitle": "Hosting, CMS, SSL, pages and email - all-in-one foundation for your website.",
        "tooltip": "Everything you need to get online quickly and securely."
      },
      "techConcierge": {
        "title": "Tech Concierge",
        "subtitle": "Ongoing expert help and development bursts - on your terms.",
        "tooltip": "Use our dev team when and how you need them."
      },
      "growthOptimize": {
        "title": "Growth & Content Strategy",
        "subtitle": "Traffic, leads, content and CRM - upgrade your visibility and funnels.",
        "tooltip": "All-in packages to scale what already works."
      },
      "visualIdentity": {
        "title": "Visual Identity & Brand Evolution",
        "subtitle": "From a light refresh to complete rebranding - upgrade how your business looks, feels and connects.",
        "tooltip": "Choose one branding track to sharpen your identity, boost visual confidence and stand out with purposeful design."
      }
    }
  },
  "components": {
    "contactForm": {
      "title": "Have a Question or Need Help?",
      "namePlaceholder": "Your Name",
      "emailPlaceholder": "Your Email",
      "subjectDefault": "Select Subject",
      "subjectGeneral": "General",
      "subjectSupport": "Support",
      "subjectCollaboration": "Collaboration",
      "messagePlaceholder": "Your Message",
      "submit": "Send Message",
      "success": "Message sent successfully!"
    },
    "header": {
      "getStarted": "Get Started",
      "language": "Language",
      "openMenu": "Open menu",
      "closeMenu": "Close menu",
      "mobileMenu": "Mobile menu",
      "menuLabel": "Menu"
    },
    "checkout": {
      "orderSummary": "Order Summary"
    }
  },
  "testimonials": {
    "items": [
      {
        "quote": "After 8 months fighting with WordPress and 3 designers who disappeared, I had my website online within 5 days with Siteoplossing. My online sales went from £0 to £12,000 in the first month.",
        "author": "Sarah W., E-commerce Owner",
        "logo": null,
        "context": "From 8 months of frustration to 5 days of success"
      },
      {
        "quote": "I didn't want to learn programming, figure out hosting or debug plugins. I wanted to run my business. That's exactly what I can do now thanks to this service.",
        "author": "Tom B., Consultant",
        "logo": null,
        "context": "From technical stress to business focus"
      },
      {
        "quote": "Three failed attempts with different agencies cost me £5000+ and 6 months. Siteoplossing delivered in a week what others couldn't in half a year.",
        "author": "Anna K., Marketing Agency",
        "logo": null,
        "context": "From agency failures to reliable results"
      }
    ],
    "items[0]": {},
    "items[1]": {},
    "items[2]": {}
  },
  "chat": {
    "offlineMessage": "Live chat is currently offline.",
    "businessHours": "Office hours: Mon–Fri, 9:00–17:00"
  },
  "hero": {
    "title": "Plan or Launch Your Dream Website Today",
    "optionBlueprintTitle": "Blueprint 100",
    "optionBlueprintDesc": "Answer a quick questionnaire and receive a custom site plan plus expert hosting advice.",
    "optionTotalTitle": "Total Package",
    "optionTotalDesc": "From design, development to maintenance of your site, stress-free service.",
    "ctaBlueprint": "Start My Free Blueprint",
    "ctaTotal": "Discover the Total Package"
  },
  "heroTotal": {
    "title": "Your Website Chases Customers Away Before They Can Buy",
    "subtitle": "Every click away is a missed sale going to your competitor.",
    "pain1": "Your website looks like a hobby project while you run a serious business.",
    "pain2": "Customers doubt your professionalism and choose the competitor.",
    "pain3": "No website? Then you're completely invisible.",
    "supporting": "Your product is great. Your website doesn't tell that story.",
    "midJourneyTitle": "Why Are You Earning Less Than You Should?",
    "midJourneyIntro": "You have experience, quality, satisfied customers. New customers only see a website that doesn't convince.",
    "deepenProblem1": "The worst part: the perfect customer came to your site but didn't trust you enough.",
    "deepenProblem2": "Meanwhile your competition grows while you're stuck."
  },
  "footer": {
    "site": {
      "tagline": "Complete, reliable and simple since 2015"
    },
    "company": {
      "title": "Company",
      "links": {
        "about": "About",
        "contact": "Contact",
        "clientLogin": "Client Login",
        "pricing": "Pricing"
      }
    },
    "legal": {
      "title": "Legal",
      "links": {
        "terms": "Terms and Conditions",
        "privacy": "Privacy Policy",
        "cookie": "Cookie Policy",
        "sla": "Service Level Agreement",
        "aup": "Acceptable Use Policy"
      }
    }
  },
  "benefits": {
    "heading": "This Is What A Professional Website Gets You",
    "urgencySubtext": "Why entrepreneurs choose a complete solution instead of struggling on their own any longer",
    "items": {
      "support": {
        "title": "Personal Guidance From A to Z",
        "amplifier": "No anonymous customer service. No referrals. I guide you personally from first conversation to launch. And remain available for questions and adjustments."
      },
      "system": {
        "title": "Website That Always Works, Never Crashes",
        "amplifier": "Reliable hosting, daily backups, security updates. Everything arranged so you don't have to worry about technical things."
      },
      "transparency": {
        "title": "Fixed Price, No Surprises",
        "amplifier": "You know exactly what you pay and what you get. No hourly rates that add up. No extra costs afterward. Just an honest, fixed price."
      },
      "focus": {
        "title": "More Time For Your Real Work",
        "amplifier": "While I build your website, you can do what you're good at: helping customers and growing your business."
      }
    }
  },
  "reassure": {
    "heading": "You're in good hands - here's why:",
    "guarantee": "From kickoff to launch - your site, ready within weeks",
    "support": "1-on-1 support for every client",
    "cancel": "Clear pricing. One year, zero surprises",
    "spotsLeft": "Only {remaining} out of {total} spots left this month!",
    "cta": "Start My Website Today - Just £30/month",
    "ctaSub": "Act fast - limited spots"
  },
  "exit": {
    "title": "Wait! Before You Go...",
    "subtitle": "Get 10% off your first month if you sign up now",
    "cta": "Claim My Discount"
  },
  "journey": {
    "steps": [
      {
        "title": "Sign Up",
        "desc": "Fill out a quick form - I'll handle the rest"
      },
      {
        "title": "Discovery Interview",
        "desc": "A 1-on-1 video call to understand your needs"
      },
      {
        "title": "Initial & Page Design",
        "desc": "I deliver a working design with 5 core pages"
      },
      {
        "title": "Feedback & Revision",
        "desc": "You review - I refine"
      },
      {
        "title": "Final Delivery & Setup",
        "desc": "Email, admin handover, and 1 hour/month free support"
      }
    ]
  },
  "social": {
    "testimonials": [
      {
        "quote": "The whole process was turnkey and stress-free. I love the results!",
        "author": "Sarah W."
      },
      {
        "quote": "I didn't have to touch a single line of code.",
        "author": "Tom B."
      }
    ]
  },
  "legalOverview": {
    "cards": [
      {
        "title": "Terms and Conditions",
        "description": "Your go-to terms for using my services.",
        "link": "/legal/terms-and-conditions"
      },
      {
        "title": "Privacy Policy",
        "description": "How I protect and use your data.",
        "link": "/legal/privacy-policy"
      },
      {
        "title": "Cookie Policy",
        "description": "Learn about my cookie usage.",
        "link": "/legal/cookie-policy"
      },
      {
        "title": "Service Level Agreement",
        "description": "My commitment to uptime and support.",
        "link": "/legal/sla"
      },
      {
        "title": "Acceptable Use Policy",
        "description": "Rules and guidelines for proper use of my services.",
        "link": "/legal/aup"
      }
    ]
  },
  "problemAgitate": {
    "heading": "Do You Recognize These Business-Killing Website Problems?",
    "paragraph1": "You choose a platform. Select a theme. Start building.\n\nThen reality hits: endless tweaks, technical roadblocks, and still no launch date in sight.\n\nMeanwhile your competitors are stealing customers online.",
    "bullet1": "Months of work without results: You've spent time you'll never get back on an \"almost ready\" website that never went live",
    "bullet2": "Competitors make sales while you're still building: Every day offline = missed customers going to others",
    "bullet3": "Technical stress instead of entrepreneurship: Your time goes to website issues instead of business growth",
    "transition": "Quick reality check: How much revenue are you losing every week without a professional website?"
  },
  "agitationTimeline": {
    "heading": "The Hard Numbers: What A Bad Website Really Costs Your Business",
    "subtitle": "Research shows what a bad first impression costs your business:",
    "stats": {
      "research": {
        "percentage": "82%",
        "description": "do online research before a purchase",
        "impact": "Without a professional website you're invisible while competitors take over your market"
      },
      "credibility": {
        "percentage": "75%",
        "description": "leave your site if it looks unprofessional",
        "impact": "3 out of 4 visitors leave immediately if your site doesn't look trustworthy."
      },
      "impression": {
        "time": "0.05",
        "description": "seconds to make the first impression",
        "visual": "CLICK → JUDGE → GONE",
        "impact": "Faster than you can blink they've already decided. And usually not in your favor."
      }
    },
    "realityCheck": {
      "title": "These Numbers Say Enough",
      "description": "It's painful to realize, but these statistics clearly show what happens. Every day without a professional website means customers going to others."
    }
  },
  "solutionBridge": {
    "hookQuestion": "Do you recognize this frustration?",
    "painAcknowledgment": "I see it with many entrepreneurs. You're good at what you do, but your website lets you down. That gnaws at you, because you know you could help more customers.",
    "heading": "There Is A Better Way",
    "empathy": "The problem isn't your entrepreneurship. The problem is that building websites is a separate profession. Just like you're a specialist in your field.",
    "transformationQuestion": "What If Your Website Actually Attracted Customers?",
    "systemDescription": "Imagine: visitors land on your site and immediately think 'this is exactly what I'm looking for'. No doubt, no hesitation.",
    "solution1": "Professional appearance that immediately builds trust",
    "solution2": "Story that clearly explains why you're the best choice",
    "solution3": "Website that convinces customers instead of chasing them away",
    "solution4": "More time for your business instead of website hassle",
    "wayForward": "You don't need to become a web designer. You just need someone who understands what entrepreneurs need.",
    "missingPiece": "Here's what you've been missing until now..."
  },
  "socialProofEnhanced": {
    "heading": "From Website Frustration to Online Success",
    "subtitle": "Real transformation stories from entrepreneurs just like you",
    "stories": [
      {
        "problem": "Months wasted on different web designers and tools. Constant re-explanations, new delays, new invoices.",
        "solution": "Finally someone who understands what entrepreneurs need. Clear communication, fixed deadlines, and a website that actually sells.",
        "author": "Pascal, Catering Van Alex",
        "result": "Professional website launched in 10 days • First sales within 48 hours • €20,000 extra revenue first year"
      }
    ],
    "problemTitle": "Problem",
    "logoCaption": "Some of my clients who came before you",
    "stats": {
      "websitesHelped": "Websites helped",
      "averageLaunchTimeNumber": "2 weeks",
      "averageLaunchTime": "Average launch time",
      "clientSatisfaction": "Client satisfaction"
    }
  },
  "finalCTA": {
    "heading": "Start Your Website This Week",
    "trustSignal1": "8 Smart Questions: Instant Personalized Plan",
    "trustSignal2": "Custom Package Selection: Perfect Fit for Your Business",
    "urgencyMessage": "Still {remaining} spots available for this month"
  },
  "scarcity": {
    "spotsRemaining": "Only {spots} out of {total} spots left this month",
    "explanation": "We work personally with every client. That's why we accept a maximum of 20 new projects per month."
  },
  "riskReversal": {
    "heading": "My Quality Commitments to You",
    "subtitle": "Here's what you can count on",
    "guarantee": {
      "title": "Launch Guarantee",
      "description": "From kickoff to launch - your site ready within weeks"
    },
    "launch": {
      "title": "Customer Experience Focused",
      "description": "1-on-1 support for every client"
    },
    "support": {
      "title": "Transparent Pricing",
      "description": "Clear pricing. Agreed upfront, zero surprises"
    }
  },
  "customerJourney": {
    "heading": "Struggling to build a website yourself?",
    "summaryPoint1Title": "You Talk, I Listen",
    "summaryPoint1Desc": "We kick off with the Blueprint 100 - a smart, guided form that captures your vision. Then we dive deeper in a real conversation to tailor everything to you.",
    "summaryPoint2Title": "You See, I Shape",
    "summaryPoint2Desc": "You receive a beautiful, custom design - and we revise it together until it fits you like a glove.",
    "summaryPoint3Title": "We Launch, I've Got Your Back",
    "summaryPoint3Desc": "From setup to support, I stay with you. Enjoy monthly adjustments, quick fixes and complete peace of mind.",
    "steps": [
      {
        "title": "Sign Up",
        "desc": "Fill out the quick lead form with your name and email."
      },
      {
        "title": "Discovery Interview",
        "desc": "Meet via a 1-on-1 video call to understand your goals."
      },
      {
        "title": "Initial 5-Page Design",
        "desc": "I deliver a complete design within 1 week for feedback."
      },
      {
        "title": "Feedback & Revision Meeting",
        "desc": "I refine the site based on your comments and preferences."
      },
      {
        "title": "Final Delivery & Setup",
        "desc": "You get your live site, custom domain and email setup."
      },
      {
        "title": "Ongoing Support",
        "desc": "Enjoy 1 hour/month free support and adjustments via ticket."
      }
    ],
    "form": {
      "title": "Start With Your Total Package",
      "submit": "Start Now",
      "microcopy": "No credit card required"
    },
    "fallback": {
      "title": "Still hesitating?",
      "text": "Not sure if my Total Package is right for you? Schedule a free consultation to learn more!",
      "button": "Schedule a Consultation"
    }
  },
  "deep": {
    "heading": "Still Have Questions? Let's Go Deeper",
    "faqTitle": "Frequently Asked Questions",
    "faq": [
      {
        "question": "What is the exact timeline from start to launch?",
        "answer": "Most websites are ready in 1-2 weeks, depending on how quickly you complete the Blueprint100 questionnaire and approve revisions."
      },
      {
        "question": "Do I need technical skills?",
        "answer": "Nope. I ensure everything is taken care of - from setup to launch. There are also packages designed to grow your website further. From Search Engine Optimization, User Experience Optimization and Conversion Rate Optimization. Packages designed to get even more out of your website."
      },
      {
        "question": "What if I don't know what I want yet?",
        "answer": "No worries - I can help you with different options. We can schedule a 1-on-1 discovery call where I help you clarify your goals and recommend which plans work best. Prefer to explore first? You can also complete the quick 8 questions 'Quick Planner' or you can also use the more comprehensive Blueprint 100: a step-by-step questionnaire that turns your ideas into a custom website plan."
      },
      {
        "question": "Is the domain and email included?",
        "answer": "The domain is not included by default - it's a standalone add-on for £15 per year, including free SSL and managed DNS. Prefer to keep your domain elsewhere? No problem - I give step-by-step instructions so you can configure everything yourself. Email setup is included either way."
      },
      {
        "question": "What support do I get after launch?",
        "answer": "After launch I ensure your website stays online 24/7, your server is secure, and all services - like email - keep running smoothly. Plus you get 20 minutes of free updates every month. Need bigger changes or new features? I'm happy to help with project-based pricing - or you can choose from a range of fixed-price packages with clear routines like CRO optimization, SEO audits, or website analytics setups that drive real growth."
      },
      {
        "question": "Can I update the website myself later?",
        "answer": "Yes! I give admin access and a short guide, so you can make simple adjustments at any time."
      },
      {
        "question": "What if I want to add more pages or features later?",
        "answer": "I grow with you. Additional work can be booked as needed, and I always quote before I start."
      },
      {
        "question": "Can I request a refund if I change my mind?",
        "answer": "I don't offer refunds once work begins, but you can cancel at any time before the project starts."
      },
      {
        "question": "Is this better than a DIY builder like Wix or Squarespace?",
        "answer": "Yes - with my Total Package I do all the work, tailor everything to your business, and offer ongoing support."
      }
    ],
    "compareTitle": "What's the Difference?",
    "compareSubtitle": "Compare my Total Package with typical DIY options",
    "compare": {
      "total": "Total Package",
      "basic": "DIY Builders",
      "features": [
        {
          "name": "Done-for-You Setup",
          "total": "Included - I handle everything",
          "basic": "You do it yourself"
        },
        {
          "name": "Discovery Call",
          "total": "1-on-1 video call to understand your goals",
          "basic": "No personalized guidance"
        },
        {
          "name": "Custom Website Design",
          "total": "Tailored to your brand & audience",
          "basic": "Choose a generic template"
        },
        {
          "name": "Content Writing Support",
          "total": "I guide or write up to 1200 words",
          "basic": "You're on your own"
        },
        {
          "name": "Revisions Included",
          "total": "One round of changes after feedback",
          "basic": "Manual adjustments with limited tools"
        },
        {
          "name": "Domain & Email Setup",
          "total": "Included & fully configured",
          "basic": "Buy & connect separately"
        },
        {
          "name": "1-on-1 Monthly Support",
          "total": "1 hour/month included via email or ticket",
          "basic": "Pay extra or no support"
        },
        {
          "name": "Admin Access & Handover",
          "total": "Full control with training if needed",
          "basic": "You manage everything from the start"
        },
        {
          "name": "Focus on Your Business",
          "total": "I handle the tech, you stay focused",
          "basic": "Distracted learning tools, plugins & fixes"
        },
        {
          "name": "Time Investment",
          "total": "1 hour (I do everything)",
          "basic": "40+ hours learning & building"
        },
        {
          "name": "Risk",
          "total": "Fixed price guarantee",
          "basic": "Unknown costs & time"
        },
        {
          "name": "Result",
          "total": "Professional from day 1",
          "basic": "Amateur appearance during learning process"
        }
      ]
    }
  },
  "totalForm": {
    "heading": {
      "step1": "Let's start with your contact details",
      "step2": "What do you need help with?",
      "step3": "Do you want to schedule an appointment now?"
    },
    "step0": {
      "title": "Let's build something great for your business",
      "desc": "Answer 3 quick questions and I'll put together a website plan specific to you",
      "note": "Takes less than 1 minute",
      "cta": "Start My Website Today"
    },
    "needsOptions": ["Launch a new website", "Improve my current one", "Something else"],
    "placeholders": {
      "name": "Your Name",
      "email": "Your Email"
    },
    "step3": {
      "desc": "You can choose a time directly for a free consultation, or decide later.",
      "now": "Yes, I'll schedule my consultation now",
      "later": "No, I'd rather decide later"
    },
    "step4": {
      "title": "Schedule Your Free Consultation",
      "desc": "Choose a time that works best for you. My team is ready to help you get started."
    },
    "gdpr": {
      "title": "Would you like to receive a reminder?",
      "desc": "You haven't scheduled a consultation yet. Would you like me to send you a follow-up email as a reminder?",
      "agree": "Yes, send me a reminder",
      "decline": "No thanks"
    },
    "goodbye": {
      "title": "No problem!",
      "desc": "You chose not to receive follow-up emails. I respect that.",
      "cta": "If you change your mind, you can always contact me via my contact page."
    },
    "progress": "Step {step} of 3",
    "privacy": "I use this info to contact you. Never spam.",
    "thanks": "Thanks! I'll be in touch soon.",
    "followup": "You'll receive an email within 1 business day with next steps.",
    "next": "Next"
  },
  "smartLeadForm": {
    "next": "Next",
    "progress": "Step {step} of {total}",
    "step2": {
      "title": "What's your main goal?",
      "options": {
        "getClients": "Get more clients",
        "showcase": "Showcase my work",
        "sellProducts": "Sell products online",
        "needHelp": "I need help with my website"
      }
    },
    "start": {
      "title": "Take The 2-Minute Quiz",
      "desc": "Just answer 5 quick questions and you'll get a plan that fits your business, your pace, and your goals.",
      "cta": "Give Me My Launch Plan - 2 Minutes",
      "note": "No jargon. No pressure. Just clarity."
    },
    "situation": {
      "title": "What is your current situation?",
      "options": {
        "starting": "I'm starting from scratch — need website + everything",
        "haveWebsite": "Have existing website — want more customers & growth",
        "needMaintenance": "Have existing website — want maintenance & fixes"
      }
    },
    "primaryGoal": {
      "title": "What is your main goal right now?",
      "options": {
        "buildWebsite": "Get my website live and launch",
        "getClients": "Bring in more leads & customers online",
        "fixMaintain": "Improve & maintain current website"
      }
    },
    "involvement": {
      "title": "How involved do you want to be?",
      "options": {
        "handsOff": "Do everything for me",
        "collab": "I want to collaborate — I'll give input",
        "diyHelp": "Guide me through it — I want to learn how it works"
      }
    },
    "timeline": {
      "title": "What is your timeline?",
      "options": {
        "now": "Start now — I'm ready to begin",
        "soon": "Start within 30 days",
        "exploring": "I'm exploring my options"
      }
    },
    "investment": {
      "title": "What can you invest for growth?",
      "options": {
        "starter": "€30-200/month + €500 one-time — Basic website & essentials",
        "professional": "€200-500/month + €1500 one-time — Growth & optimization",
        "premium": "€500+/month + €3000+ one-time — Premium all-inclusive"
      }
    },
    "planReady": {
      "title": "Your Personal Plan Is Ready",
      "description": "Based on your answers, I've selected the best-fitting packages to help you launch with clarity and speed.",
      "recommendedTitle": "Recommended for you:",
      "moreProducts": "+ {count} more packages",
      "cta": "Show Me My Recommended Plans",
      "ctaLabel": "Explore my plan options",
      "note": "Tailored to your goals. Fully transparent pricing."
    },
    "contact": {
      "title": "Where should I send your plan summary?",
      "namePlaceholder": "Your name",
      "emailPlaceholder": "Your email address",
      "cta": "Email Me The Plan"
    },
    "gdpr": {
      "title": "Want tips & tools to grow online?",
      "desc": "Occasional emails with growth tips, no spam. You can always unsubscribe.",
      "accept": "Yes, send me tips",
      "decline": "No thanks"
    }
  },
  "terms": {
    "title": "Terms and Conditions",
    "subtitle": "Clear and understandable terms for using our services",
    "intro": "Every time you enter into an agreement with Siteoplossing, my standard terms and conditions apply. Curious what all those legal terms mean? I've translated them into clear and understandable language for you.",
    "full_version_link": "full version",
    "agreement_title": "Your Agreement with Siteoplossing",
    "agreement_text": "An agreement is created when you register and place an order with us, with my terms and conditions as guidance. Depending on what you order, the duration can vary: one year for domain names (with automatic renewal) and SSL certificates (without automatic renewal), and monthly to yearly for all other services.",
    "external_conditions_title": "External Conditions and Your Consent",
    "external_conditions_text": "Sometimes I need other companies to deliver services to you. If applicable, you agree through us to their additional terms.",
    "account_info_title": "Your Account Information",
    "account_info_text": "You manage your services through a control panel accessible via your account, for which I need accurate information. Report changes directly.",
    "maintenance_backups_title": "Maintenance and Backups",
    "maintenance_backups_text": "To keep services optimal, maintenance is sometimes needed, and I make regular backups that are available on your request.",
    "upgrades_domains_title": "Upgrades and Domain Registration",
    "upgrades_domains_text": "Upgrades are always possible; downgrades require ending your current agreement and starting a new one. I handle the paperwork for your domain name and other registrations.",
    "payments_price_title": "Payments and Price Adjustments",
    "payments_price_text": "You pay in advance for recurring costs and after for one-time costs. I can adjust prices with advance notice.",
    "use_of_services_title": "Your Use of Services",
    "use_of_services_text": "Use the services responsibly, without damage to my network or others. Violations can lead to service suspension.",
    "rights_data_title": "Your Rights and Data Processing Agreement",
    "rights_data_text": "You retain rights to your data. As a consumer, you can cancel a service within 14 days, except for domain and SSL registrations. A data processing agreement is required for processing others' data.",
    "termination_title": "Termination of Services",
    "termination_text": "You can cancel with one month's notice. Make sure to secure your data before termination, and know that you're always welcome to return."
  },
  "privacy": {
    "title": "Privacy Policy",
    "subtitle": "How we protect and handle your personal data",
    "intro_text": "At Siteoplossing, I only collect the minimal data needed to deliver my services and improve your experience with my product pages. Your data is handled carefully to protect your privacy.",
    "our_promises_title": "My Four Promises to You",
    "our_promises_list": [
      "I protect your personal data as if it were my own.",
      "Your personal data is used exclusively for the purposes described in this statement.",
      "I don't store your data longer than strictly necessary.",
      "I never share your personal data with third parties without valid reason."
    ],
    "personal_data_title": "What Personal Data Does Siteoplossing Process?",
    "personal_data_intro": "To fulfill the agreement you enter into with us, I need certain information from you:",
    "personal_data_list": [
      "Name and Address: For communication, billing and maybe even a coffee when you visit.",
      "Company Information: If you use my business services, I keep this separate from your personal information.",
      "Email Address: For important notifications about your order or account, and updates via newsletters, with the option to unsubscribe.",
      "Phone Number: For emergencies, feedback, two-factor authentication or monitoring your VPS.",
      "Login Details and Customer Number: To keep your account secure and help you faster.",
      "IP Address: To track account access and help protect against unauthorized access.",
      "Payment Information: To process your orders and payments, including through payment services like PayPal."
    ],
    "other_data_title": "Other Data Processed by Siteoplossing",
    "other_data_intro": "Not all data is essential for delivering my services. Sometimes I collect additional information based on your consent or a legitimate interest:",
    "other_data_list": [
      "Work-Related Personal Data: For job applications. If you're not hired, your information is deleted within 12 months.",
      "Cookies: To analyze your user experience and personalize my website and advertisements. You can withdraw your consent at any time.",
      "Server Logs: Automatically collected data like your IP address and browser version, used to secure my systems and troubleshoot errors.",
      "Crash Data: Data collected to analyze and prevent crashes in my app, stored for a maximum of 3 months."
    ],
    "purpose_title": "Purpose of Data Processing",
    "purpose_text": "Siteoplossing processes your personal information for clear purposes: granting access to my services, maintaining website functionality, fulfilling your agreement, staying in touch, handling complaints, ensuring security and fraud prevention, and responding to job applications.",
    "purpose_consent_text": "With your consent, I may also use your information to analyze and improve my website and services, personalize content and advertisements, and share promotions that match your interests.",
    "security_title": "Security",
    "security_text": "I am committed to strong security measures to prevent misuse and unauthorized access to your data, including the use of SSL certificates for secure data transfer.",
    "third_parties_title": "Your Privacy and Third Parties",
    "third_parties_text": "Your data is only shared in specific situations, such as delivering my services, complying with legal obligations, or registering domain names. With your consent, I may share data to improve my services, distinguish people from bots with tools like reCAPTCHA, or collect feedback through research agencies.",
    "automated_decisions_title": "Automated Decisions",
    "automated_decisions_text": "Automated decisions, such as sending alerts for missed payments, are made based on your data. Persistent non-payment may result in blocked or even terminated services.",
    "cookies_title": "Cookies",
    "cookies_text": "Cookies may contain personal data; see my cookie policy for more details.",
    "third_party_websites_title": "Third Party Websites",
    "third_party_websites_text": "My privacy and cookie policy does not apply to third party websites I link to. Check their policies before sharing personal data.",
    "privacy_rights_title": "Your Privacy Rights",
    "privacy_rights_text": "As a user, you have the right to view, correct or delete your data, or object to processing. Contact me through your control panel or contact my support team for help or to file a complaint.",
    "contact_title": "Contact Information",
    "contact_info": {
      "company": "Siteoplossing",
      "address": "Parkweg 100, 6511 BK Nijmegen",
      "email": "contact [at] siteoplossing.nl",
      "linkedin": "https://www.linkedin.com/company/siteoplossing",
      "kvk": "57753938",
      "vat": "NL004847619B65"
    }
  },
  "cookie": {
    "title": "Cookie Policy",
    "subtitle": "How we use cookies to improve your experience",
    "intro": "Cookies are small text files stored on your device when you visit my site. They allow you to automatically log in and remember what you have in your shopping cart thanks to stored information. Cookies also help me analyze your use of the site and determine which services you find attractive. There are different types of cookies: functional for basic operation, analytical for usage insights, and marketing cookies for personalized advertisements. You can always adjust your cookie preferences through the privacy settings page.",
    "functionalCookiesTitle": "Functional cookies",
    "functionalCookiesText": "I use functional cookies to store your preferences and keep products in your cart.",
    "functionalCookiesTable": {
      "headers": ["Cookie Name", "Max Retention", "Placed By", "Purpose"],
      "rows": [
        [
          "WHMCSInstanceID",
          "End of session",
          "WHMCS / client.siteoplossing.nl",
          "Stores a unique session ID to maintain status between page loads."
        ],
        [
          "WHMCSUser",
          "365 days",
          "WHMCS / client.siteoplossing.nl",
          "Used for 'remember me' functionality so you don't have to log in repeatedly."
        ]
      ]
    },
    "analyticsCookiesTitle": "Analytical cookies",
    "analyticsCookiesText": "I use analytical cookies to understand how you use my site and improve it.",
    "analyticsCookiesTable": {
      "headers": ["Cookie Name", "Max Retention", "Placed By", "Purpose"],
      "rows": [["g_state", "30-07-2024 12:00:06", "siteoplossing.nl", "Used for analyzing website usage."]]
    },
    "marketingCookiesTitle": "Marketing cookies (performance, affiliate, and tracking)",
    "marketingCookiesText": "Performance cookies measure advertising success, affiliate cookies link sales to partners, and tracking cookies follow product interest.",
    "marketingCookiesTable": {
      "headers": ["Cookie Name", "Max Retention", "Placed By", "Purpose"],
      "rows": [
        [
          "WHMCSAffiliateID",
          "90 days",
          "WHMCS / client.siteoplossing.nl",
          "Stores affiliate ID for customer referrals within 90 days."
        ],
        [
          "WHMCSLinkID",
          "Persistent",
          "WHMCS / client.siteoplossing.nl",
          "Tracks the original link used by the visitor for conversion tracking."
        ]
      ]
    },
    "deletingCookiesTitle": "Deleting and disabling cookies",
    "deletingCookiesText": "Cookies are automatically deleted after their retention period. You can also manually delete or block cookies through your browser settings.",
    "lastUpdated": "This page was last updated on 06/02/2024."
  },
  "sla": {
    "title": "Service Level Agreement",
    "subtitle": "Our commitment to service availability and your rights",
    "intro": "Siteoplossing strives to keep your services available at all times. However, there may be times when this is not possible. In this section I clarify your rights when a service becomes unavailable. Interested in the legal details? You can find the ",
    "full_version_link": "full legal version here",
    "webhosting_title": "Web Hosting Services",
    "webhosting_text_1": "Siteoplossing offers a 99.95% monthly uptime guarantee for web hosting. This means your website will not be offline for more than about 22 minutes per month. If your website was unavailable longer, you are entitled to compensation.",
    "webhosting_text_2": "You can request compensation through the control panel, and it will be credited to your next invoice.",
    "webhosting_text_3": "You can calculate the amount of compensation with the following formula:",
    "webhosting_formula": "(Monthly Web Hosting Costs / Number of Minutes in the Month) × (Downtime Minutes - 22) × 100",
    "webhosting_max_compensation": "The maximum compensation is the monthly cost of your web hosting service.",
    "other_services_title": "Other Services",
    "other_services_text_1": "I don't offer an explicit uptime guarantee for my other services.",
    "other_services_text_2": "You may be eligible for compensation if your service was unavailable for more than two hours. To claim compensation, you can contact me through the control panel.",
    "other_services_formula": "(Monthly Service Costs / Total Minutes in the Month) × (Downtime Minutes - 120)"
  },
  "aup": {
    "title": "Acceptable Use Policy",
    "subtitle": "Guidelines for responsible use of our services",
    "intro": "With Siteoplossing's Total Package, I want to give you a complete, worry-free experience. To keep everything running smoothly, I've made a few clear agreements. Prefer to read the full legal text? You can find it here: ",
    "full_version_link": "legal version",
    "scope_title": "What's in the Total Package?",
    "scope_list": [
      "3 GB web hosting space.",
      "50 GB data traffic per month.",
      "Unlimited number of email addresses.",
      "A basic website of maximum 5 pages, developed together with you.",
      "Basic SEO optimization (page titles, meta tags, internal links)."
    ],
    "maintenance_title": "Updates and Maintenance",
    "maintenance_text_1": "I ensure your website stays safe and up-to-date with regular security and software updates.",
    "maintenance_text_2": "For planned maintenance, I give you at least 48 hours notice in advance.",
    "maintenance_text_3": "Urgent security updates may be performed without prior notice.",
    "support_title": "Support",
    "support_text_1": "Need help? I'm available on weekdays from 9:00 to 17:00 via email, phone, tickets or chat.",
    "support_text_2": "I strive to respond within 24 hours. Note: this is a substantive response, not a guarantee of immediate solution.",
    "support_text_3": "I offer up to 1 hour of free support per month. Any additional work outside the package is always discussed beforehand.",
    "other_title": "Other Agreements",
    "other_text_1": "For matters like backups, service termination or liability, my general terms and conditions apply.",
    "other_text_2": "By using the Total Package, you agree to these terms of use."
  },
  "dashboard": {
    "overview": "Overview",
    "users": "Users",
    "sales": "Sales",
    "revenue": "Revenue",
    "orders": "Orders",
    "trends": "Trends",
    "chartPlaceholder": "Chart goes here"
  },
  "ui": {
    "title": "Create Your Perfect Website—Step by Step",
    "next": "Next",
    "back": "Back",
    "summary_section": "Check Your Blueprint",
    "yes": "✔️ Yes",
    "no": "❌ No",
    "download_pdf": "Download PDF",
    "send_email": "Send to my email",
    "email_subject": "Your Site Blueprint – {score}/100",
    "email_body": "Here is your personalized site blueprint!",
    "inputs": {
      "pick_an_option": "Pick an option",
      "selected_option": "Selected Option",
      "fontexample": "The quick brown fox jumps over the lazy dog",
      "pagination": {
        "previous": "Previous",
        "next": "Next"
      },
      "chooseColorPalette": "Choose a color palette"
    }
  },
  "schema": {
    "projectFoundation": {
      "title": "Project Foundation",
      "questions": {
        "foundationDomain": {
          "label": "Your Target Domain",
          "placeholder": "e.g. mybusiness.com",
          "help": "Where will customers find you online?",
          "summaryLabel": "Domain:"
        },
        "foundationGoals": {
          "label": "Primary Website Goals",
          "help": "Select goals that align with your top priorities.",
          "summaryLabel": "Goals:",
          "options": {
            "leadCapture": "Capture Leads",
            "ecom": "Drive Sales",
            "portfolio": "Showcase Work",
            "blog": "Build Authority",
            "other": "Other",
            "notSure": "Not sure"
          }
        },
        "foundationLaunchTimeline": {
          "label": "Launch Timeline",
          "help": "When do you need to go live to capture important opportunities?",
          "summaryLabel": "Timeline:",
          "options": {
            "immediate": "Within 2 weeks",
            "month": "1 month",
            "quarter": "2–3 months",
            "undecided": "Undecided"
          }
        },
        "foundationNeededPages": {
          "label": "Core Web Features",
          "help": "What pages or functionalities should your site include?",
          "summaryLabel": "Features:",
          "options": {
            "notSure": "Not sure about this",
            "contactForm": "Contact Form",
            "ecommerceCart": "E-commerce Cart",
            "blog": "Blog",
            "faqSection": "FAQ Section",
            "portfolioGallery": "Portfolio Gallery",
            "bookingSystem": "Booking System",
            "userLogin": "User Login",
            "chatbotSupport": "Chatbot Support",
            "newsletterSignup": "Newsletter Signup",
            "eventsCalendar": "Events Calendar",
            "multiLanguageSupport": "Multi-language Support",
            "analyticsDashboard": "Analytics Dashboard"
          }
        }
      }
    },
    "storyCredibility": {
      "title": "Story & Credibility",
      "questions": {
        "credibilityOneLiner": {
          "label": "Elevator Pitch",
          "placeholder": "In one sentence, what makes you unique?",
          "help": "Create a concise statement that highlights your unique value.",
          "summaryLabel": "Pitch:"
        },
        "credibilityMission": {
          "label": "Core Mission & Pain",
          "placeholder": "Describe the biggest challenge you solve",
          "help": "What pain points do you address for your customers?",
          "summaryLabel": "Mission/Pain:"
        },
        "credibilityAssets": {
          "label": "Social Proof Assets",
          "help": "Upload testimonials, case studies or logos that build credibility.",
          "summaryLabel": "Proof:"
        },
        "credibilityTrustSignals": {
          "label": "Trust-Building Elements",
          "help": "What kind of social proof can you provide right now?",
          "summaryLabel": "Trust Signals:",
          "options": {
            "dontHaveAny": "Don't have any at the moment",
            "testimonials": "Customer Testimonials",
            "certifications": "Certifications",
            "awards": "Awards",
            "press": "Press Mentions",
            "logos": "Customer Logos"
          }
        },
        "credibilityToneGrid": {
          "label": "Brand Personality",
          "help": "Choose the voice that resonates most with your audience.",
          "summaryLabel": "Personality:",
          "options": {
            "professional": "Professional",
            "playful": "Playful",
            "luxury": "Luxury",
            "friendly": "Friendly",
            "innovative": "Innovative",
            "notSure": "I'm not sure about this"
          }
        }
      }
    },
    "designBranding": {
      "title": "Design & Branding",
      "questions": {
        "brandingPrimaryColor": {
          "label": "Signature Color",
          "help": "Choose the color that best represents your brand's essence.",
          "summaryLabel": "Color:"
        },
        "brandingPalette": {
          "label": "Supporting Palette",
          "help": "Select complementary colors for consistency.",
          "summaryLabel": "Palette:"
        },
        "brandingFont": {
          "label": "Typography Style",
          "help": "Which font conveys your brand's character?",
          "summaryLabel": "Font:"
        },
        "brandingStyles": {
          "label": "Design Elements",
          "help": "Which design aesthetics align with your identity?",
          "summaryLabel": "Styles:",
          "options": {
            "minimalist": "Minimalist",
            "illustrative": "Illustrative",
            "photography": "Photography-driven",
            "boldTypography": "Bold Typography",
            "darkMode": "Dark Mode"
          }
        },
        "brandingLogoUpload": {
          "label": "Logo File",
          "help": "Upload your logo file (PNG/SVG).",
          "summaryLabel": "Logo:"
        }
      }
    },
    "contentStructure": {
      "title": "Content & Structure",
      "questions": {
        "contentCorePages": {
          "label": "Core Pages",
          "help": "Select which pages you want to include",
          "summaryLabel": "Pages:",
          "options": {
            "home": "Home",
            "about": "About",
            "services": "Services",
            "contact": "Contact",
            "blog": "Blog",
            "faq": "FAQ"
          }
        },
        "contentKeywords": {
          "label": "Target Topics & Keywords",
          "placeholder": "List up to 10 high-impact terms",
          "help": "What topics or keywords attract your ideal customers?",
          "summaryLabel": "Keywords:"
        },
        "contentWritingStyle": {
          "label": "Writing Style Preferences",
          "help": "Select the formats and structures that best match how your audience reads.",
          "summaryLabel": "Style:",
          "options": {
            "concise": "Concise & To-the-Point",
            "narrative": "Story-Driven Narratives",
            "analytical": "Data-Heavy & Analytical",
            "conversational": "Conversational & Friendly",
            "visual": "Visually Structured (lists, headers)",
            "seo": "SEO-Focused & Keyword-Rich",
            "unsure": "Not sure yet"
          }
        },
        "contentBlogChoices": {
          "label": "Blog/News Format",
          "help": "What types of blog or news updates do you want to publish?",
          "ariaLabel": "Select the types of blog or news updates",
          "summaryLabel": "Selected Blog Formats:",
          "options": {
            "articles": "In-depth Articles (how-to's, thought leadership)",
            "news": "Company News & Announcements",
            "caseStudies": "Case Studies & Success Stories",
            "quickGuides": "Quick Tips & Practical Guides",
            "undecided": "Undecided (help me choose)"
          }
        }
      }
    },
    "integrationsMarketing": {
      "title": "Integrations & Marketing",
      "questions": {
        "marketingExistingTools": {
          "label": "Existing Marketing Tools",
          "help": "What tools are you already using?",
          "summaryLabel": "Tools:",
          "options": {
            "dontNeed": "I don't need this",
            "mailchimp": "Mailchimp",
            "hubspot": "HubSpot",
            "ga": "Google Analytics",
            "zapier": "Zapier",
            "stripe": "Stripe",
            "none": "None"
          }
        },
        "marketingSocial": {
          "label": "Social Platforms",
          "help": "Which social platforms will you promote on?",
          "summaryLabel": "Social:",
          "options": {
            "facebook": "Facebook",
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "twitter": "Twitter",
            "tiktok": "TikTok",
            "other": "Other",
            "dontHave": "I don't have this"
          }
        },
        "marketingFunnel": {
          "label": "Customer Funnel Description",
          "placeholder": "Map the steps from prospect to buyer",
          "help": "Describe how you currently convert people into customers.",
          "summaryLabel": "Funnel:"
        },
        "marketingApiGrid": {
          "label": "API Integrations",
          "help": "Which API integrations have priority?",
          "summaryLabel": "Integrations:",
          "options": {
            "dontNeed": "Don't think I need this",
            "crm": "CRM",
            "payment": "Payment Gateway",
            "analytics": "Analytics",
            "automation": "Marketing Automation",
            "custom": "Custom API"
          }
        },
        "marketingGrowthTactics": {
          "label": "Growth Strategies",
          "help": "Which tactics would you like to test for rapid growth?",
          "summaryLabel": "Tactics:",
          "options": {
            "seo": "SEO",
            "ppc": "PPC Ads",
            "email": "Email Campaigns",
            "referral": "Referral Program",
            "abTesting": "A/B Testing",
            "dontNeed": "Don't think I need this"
          }
        }
      }
    }
  },
  "aboutPage": {
    "hero": {
      "title": "SiteOplossing: Premium Tools & Support, Built for You",
      "subtitle": "One developer. Personalized service. Powerful solutions.",
      "cta": "Let's Talk"
    },
    "story": {
      "heading": "Who's Behind Siteoplossing?",
      "description": "I'm a solo developer passionate about creating tools and services that empower others. With a focus on quality and care, Siteoplossing is my way of offering premium support and digital craftsmanship.",
      "cards": {
        "experience": {
          "title": "Years Experience",
          "body": "10+ in software & web development"
        },
        "clients": {
          "title": "Satisfied Clients",
          "body": "More than 100+ supported businesses"
        },
        "focus": {
          "title": "Focus Areas",
          "body": "Hosting, SaaS tools, fullstack apps"
        }
      }
    }
  },
  "progressBar": {
    "aria": "Step {current} of {total} – {percent}% complete"
  },
  "triggeredRecommendations": {
    "hereIsWhy": "Here's why this setup is tailored for you",
    "budgetBasedTitle": "Based on Your Budget",
    "goalBasedTitle": "Based on Your Goals",
    "budgetExplanation": {
      "starter": "These packages fit perfectly within your €30-200/month budget:",
      "professional": "Maximum value within your professional budget range:",
      "premium": "Your premium budget unlocks access to my most comprehensive solutions:"
    },
    "goalExplanation": {
      "getClients": "For more clients, I've added growth-focused services:",
      "haveWebsite": "For website optimization, these services are recommended:",
      "handsOff": "For hands-off management, I handle everything for you:",
      "default": "Based on your needs, these services will help you succeed:"
    },
    "croBridgeTitle": "I've analyzed your answers and matched you with an ideal setup - pre-selected for speed and impact. You have control: feel free to adjust, but this combo works perfectly for most clients.",
    "build": {
      "standardPackage": "The Complete Website Package is your starting point - fast, secure and fully managed. Gives you everything for professional launch: standard template, 5 pages/1200 words and 30 products.",
      "ecommercePro": "For E-commerce, Complete Website Package+ adds 20 GB hosting and priority support for higher traffic and transactions.",
      "domainManaged": "I handle domain registration, DNS setup, renewals and SSL - you can focus on growth."
    },
    "tech": {
      "conciergeFree": "Tech Concierge keeps your site secure and up-to-date with backups, security scans and quick fixes - plus free monthly website changes.",
      "contentSupport1h": "For custom content or blog support - Tech Concierge +1 hour gives dedicated time for updates and feature tweaks.",
      "contactOrAssets5h": "For custom Contact setup or asset integration - my 5-hour Dev Sprint delivers hands-on support for APIs, themes and dev handover."
    },
    "content": {
      "blogSeoAi": "For regular SEO blog posts - AI Content (5 Posts) generates optimized articles with your keywords.",
      "proCopywriting5": "For professionally written pages - Copywriting (5 Pages) delivers brand-voice content with SEO and revisions.",
      "keywordResearch": "For more organic traffic - Keyword Research analyzes high-intent keywords and provides on-page optimization guidance.",
      "monthlyGrowthCall": "For strong foundation and strategic roadmap - Monthly Growth Strategy Call provides expert guidance and custom marketing plan.",
      "crmIntegration": "For CRM integration - my CRM Workflow Setup automates your lead funnel with custom form workflows."
    },
    "optimize": {
      "professionalUx": "For professional/minimalist feel - Usability Testing discovers user pain points with session recordings and heatmaps.",
      "logoRefresh": "With your uploaded logo - Brand Visual Refresh modernizes your identity with updated logo, palette & mockups.",
      "multilingual7plus": "For translations of 7+ pages or custom social content - Multilingual Translation ensures native-reviewed, culturally accurate copy."
    },
    "direct": {
      "growthAnalytics": "Monthly Growth Strategy Call provides insight into what works. Data-driven decisions for faster growth.",
      "seoOpportunity": "SEO Opportunity Amplifier identifies opportunities competitors miss—more visibility means more clients.",
      "brandRefresh": "Mini Brand Refresh ensures professional and memorable first impression—unique branding based on your business."
    },
    "budget": {
      "starter": "Your €50-150/month budget fits perfectly with starter packages - everything for professional launch without unnecessary costs.",
      "professional": "With your €150-400/month growth budget, I can equip you with advanced tools for scale and optimization.",
      "premium": "Your €500+/month premium budget unlocks my complete suite - from content to conversion optimization."
    },
    "situation": {
      "noWebsite": "Without an existing website, I've selected a complete startup setup with hosting, domain and everything to get online.",
      "outdatedWebsite": "Your website needs an upgrade - I've chosen packages that improve conversions and generate more leads."
    },
    "goal": {
      "moreLeads": "For more clients, I've added SEO, content and analytics tools to expand your online reach.",
      "maintenance": "For reliable support, tech concierge services ensure your website stays up-to-date and secure."
    },
    "involvement": {
      "handsOff": "With limited time for marketing, I've added content and support services so everything gets handled."
    },
    "urgency": {
      "immediate": "For your urgent timeline, I've added extra support to ensure everything runs quickly and smoothly."
    },
    "focus": {
      "ecommerce": "For e-commerce success, conversion optimization and analytics are essential - that's why they're added to your package.",
      "b2bService": "As a B2B service provider, authority content and professional branding are crucial for building client trust."
    },
    "fallback": {
      "description": "Not sure about this selection? Take my 2-minute quiz for a personalized recommendation.",
      "buttonText": "Get My Custom Plan"
    }
  },
  "accountCreation": {
    "title": "Let's Start With Your Account",
    "subtitle": "Set up your account to continue.",
    "alreadyRegistered": "An account with this email already exists. Log in or use a different email address."
  },
  "form": {
    "email": "Email address",
    "loading": "Checking account...",
    "continue": "Continue",
    "validation": {
      "required": "This field is required.",
      "invalidEmail": "Enter a valid email address."
    },
    "genericError": "Something went wrong. Please try again."
  },
  "journeyTimeline": {
    "title": "From Frustration To Pride In Your Website in 2 Weeks",
    "description": "While others spend months struggling, you'll have a website you're proud of within 2 weeks",
    "steps": [
      {
        "title": "Getting Acquainted",
        "desc": "You fill out the Blueprint 100 (a questionnaire that maps your website wishes), then we call briefly. This way I immediately understand what you need.",
        "duration": "30 min",
        "emotionalBenefit": "Finally someone who understands what you need"
      },
      {
        "title": "Design & Copy",
        "desc": "I create your website with copy that convinces and design that builds trust. You don't have to do anything.",
        "duration": "1 week",
        "emotionalBenefit": "Relief that it's finally happening"
      },
      {
        "title": "Your Feedback",
        "desc": "You review everything, give feedback, and I adjust until you're 100% satisfied.",
        "duration": "2 days",
        "emotionalBenefit": "Feeling of control and involvement"
      },
      {
        "title": "Go Live",
        "desc": "Website online, domain connected, email set up. Everything works, everything is arranged.",
        "duration": "1 day",
        "emotionalBenefit": "Pride that you finally have a website you stand behind"
      },
      {
        "title": "Ongoing Support",
        "desc": "Questions? Adjustments? I remain available. You're not left alone after launch.",
        "duration": "Always",
        "emotionalBenefit": "Certainty that help is always there"
      }
    ]
  },
  "pricingSummary": {
    "title": "Package Overview",
    "clarifier": "This package includes {months} months of service. You can choose to pay monthly or pay in advance",
    "ctaButton": "Go to Checkout"
  },
  "contact": {
    "heading": "Get in Touch",
    "options": {
      "ticket": {
        "title": "Send an Email",
        "description": "Expert help within 1 business day"
      },
      "consult": {
        "title": "Schedule Consultation",
        "description": "Quickly book a 1-on-1 appointment"
      },
      "chat": {
        "title": "Live Chat",
        "online": "I'm online now!",
        "offline": "Offline - office hours"
      }
    }
  },
  "thankYou": {
    "title": "Thank You for Your Order!",
    "subtitle": "I've received your order and will get started right away.",
    "invoiceLabel": "Invoice Number",
    "confirmationEmail": "You'll find a confirmation email in your mailbox within a few minutes.",
    "teamContact": "I will contact you within 24 hours to discuss your project.",
    "projectStart": "I'll begin working on your website as soon as possible.",
    "backToHome": "Back to Homepage",
    "contactUs": "Contact Us"
  },
  "countries": {
    "NL": "Netherlands",
    "BE": "Belgium"
  }
}
